export type PracticeAreaDefinition = {
  name: string;
  slug: string;
  description: string;
};

export const lexmosaicPracticeAreaCatalog: PracticeAreaDefinition[] = [
  {
    name: "AI governance and AI Act",
    slug: "ai-governance-and-ai-act",
    description: "EU AI Act readiness, AI governance programs, provider/deployer duties, risk classification, conformity workflows and AI policy implementation.",
  },
  {
    name: "AI contracting and procurement",
    slug: "ai-contracting-and-procurement",
    description: "Contracts for AI tools, model access, SaaS AI features, warranties, liability allocation, audit rights and public or enterprise AI procurement.",
  },
  {
    name: "AI copyright and training data",
    slug: "ai-copyright-and-training-data",
    description: "Copyright issues in AI training, scraping, text and data mining, output ownership, licensing strategy and rights-holder disputes.",
  },
  {
    name: "Fintech licensing and payments",
    slug: "fintech-licensing-and-payments",
    description: "Payment services, e-money, open banking, embedded finance, fintech licensing, outsourcing and regulatory perimeter analysis.",
  },
  {
    name: "Crypto-assets and tokenization",
    slug: "crypto-assets-and-tokenization",
    description: "MiCA, token issuance, custody, exchange services, stablecoins, tokenized assets and crypto regulatory structuring.",
  },
  {
    name: "NFTs and digital collectibles",
    slug: "nfts-and-digital-collectibles",
    description: "NFT drops, marketplace rules, rights licensing, consumer terms, creator royalties, gaming assets and digital collectible disputes.",
  },
  {
    name: "Blockchain infrastructure and smart contracts",
    slug: "blockchain-infrastructure-and-smart-contracts",
    description: "Smart contract legal design, DAO structures, wallet flows, DeFi protocols, validators, node infrastructure and on-chain risk allocation.",
  },
  {
    name: "Technology regulatory compliance",
    slug: "technology-regulatory-compliance",
    description: "DSA, DMA, Data Act, platform regulation, online services compliance, digital products and coordinated EU regulatory monitoring.",
  },
  {
    name: "Cybersecurity, NIS2 and incident response",
    slug: "cybersecurity-nis2-and-incident-response",
    description: "Cyber governance, NIS2 duties, breach response, regulator notification, ransomware coordination and cross-border incident playbooks.",
  },
  {
    name: "Data protection and GDPR",
    slug: "data-protection-and-gdpr",
    description: "GDPR compliance, data processing agreements, DPIAs, lawful bases, international transfers, privacy governance and authority investigations.",
  },
  {
    name: "Data governance and digital assets",
    slug: "data-governance-and-digital-assets",
    description: "Data sharing, data monetization, database rights, data access rules, digital asset governance and cross-border data strategy.",
  },
  {
    name: "Software, SaaS and cloud contracts",
    slug: "software-saas-and-cloud-contracts",
    description: "Software licensing, SaaS terms, cloud services, SLAs, implementation projects, open-source dependencies and technology outsourcing.",
  },
  {
    name: "E-commerce and consumer platforms",
    slug: "e-commerce-and-consumer-platforms",
    description: "Marketplace terms, consumer journeys, online sales, subscriptions, dark patterns, platform liability and digital consumer enforcement.",
  },
  {
    name: "Digital advertising and adtech",
    slug: "digital-advertising-and-adtech",
    description: "Adtech contracts, cookies, consent, targeted advertising, influencer marketing, platform campaigns and advertising compliance.",
  },
  {
    name: "Trade marks and brand protection",
    slug: "trade-marks-and-brand-protection",
    description: "Trade mark clearance, filing, prosecution, oppositions, enforcement, anti-counterfeiting and cross-border brand strategy.",
  },
  {
    name: "Domain names and online enforcement",
    slug: "domain-names-and-online-enforcement",
    description: "Domain name disputes, cybersquatting, UDRP, marketplace takedowns, impersonation, online brand abuse and enforcement programs.",
  },
  {
    name: "Patent litigation and technology disputes",
    slug: "patent-litigation-and-technology-disputes",
    description: "Patent infringement, validity disputes, preliminary injunctions, evidence strategy, SEP disputes and technical litigation coordination.",
  },
  {
    name: "Copyright and digital content",
    slug: "copyright-and-digital-content",
    description: "Content licensing, copyright enforcement, user-generated content, software copyright, streaming, publishing and digital media disputes.",
  },
  {
    name: "Designs and product look-and-feel",
    slug: "designs-and-product-look-and-feel",
    description: "Registered and unregistered designs, product appearance, UX/UI copying, fashion and product enforcement.",
  },
  {
    name: "Trade secrets and confidential information",
    slug: "trade-secrets-and-confidential-information",
    description: "Know-how protection, NDAs, employee mobility, source code access, confidential business information and misappropriation claims.",
  },
  {
    name: "Life sciences technology and health data",
    slug: "life-sciences-technology-and-health-data",
    description: "Medtech, health apps, clinical data, digital therapeutics, health-data compliance and technology licensing in life sciences.",
  },
  {
    name: "Gaming, metaverse and virtual worlds",
    slug: "gaming-metaverse-and-virtual-worlds",
    description: "Games publishing, virtual goods, esports, platform terms, avatar rights, immersive environments and youth protection issues.",
  },
  {
    name: "IT disputes and expert evidence",
    slug: "it-disputes-and-expert-evidence",
    description: "Failed IT projects, software defects, system implementation disputes, source-code evidence, expert reports and technology damages.",
  },
  {
    name: "IP and technology transactions",
    slug: "ip-and-technology-transactions",
    description: "IP due diligence, technology transfers, licensing, R&D collaborations, spin-outs, IP-heavy M&A and investment support.",
  },
];
